import styled from "styled-components"
import {
  Button,
  mathOperations,
  SFXS,
  Currencies,
} from "@orbital/games-frontend-library"
import { ReactComponent as AutoSVG } from "./svg/auto.svg"

import FastButton from "./fastButton/FastButton"
const fastSFX = require("../../assets/audio/fastplaybtn.mp3")
export function UpFloor({
  stake,
  handleStake,
  handleAbove,
  audio,
  handleNotification,
  gameInfo: { precision, maxBet, minBet, currency },
  colors,
}: any) {
  return (
    <Section>
      <Button
        audio={audio}
        colors={{
          textColor: colors.tertiary,
          background: colors.secondaryDark,
          borderColor: colors.secondary,
        }}
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "1/2",
              precision,
              maxBet,
              minBet,
              handleNotification,
              currency
            )
          )
        }
        SFX={SFXS.divideSFX}
        handleNotification={handleNotification}
      >
        1/2
      </Button>
      <Button
        background="transparent"
        border="3px solid #ffb000"
        textColor="#ffb000"
        // colors={{ ...colors, textColor: colors.secondary }}
        size="12px"
        audio={audio}
        width="178px"
        func={(b: boolean) => b && handleAbove("SetStake")}
        SFX={SFXS.goForwardSFX}
      >
        <Span>
          {stake}
          {Currencies[currency]}
        </Span>
      </Button>
      <Button
        audio={audio}
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "2x",
              precision,
              maxBet,
              minBet,
              handleNotification,
              currency
            )
          )
        }
        SFX={SFXS.multiplySFX}
        handleNotification={handleNotification}
        colors={{
          textColor: colors.tertiary,
          background: colors.secondaryDark,
          borderColor: colors.secondary,
        }}
      >
        2x
      </Button>
    </Section>
  )
}
export const Span = styled.span`
  display: flex;
  align-items: center;
  svg {
    margin-left: 5px;
    height: 15px;
  }
`

const aud = new Audio(fastSFX.default)
export function DownFloor({
  stake,
  sendBet,
  sendSettings,
  handleAbove,
  audio,
  speed,
  colors,
  betSent,
}: any) {
  return (
    <Section>
      {/* <Button
        audio={audio}
        func={(b: boolean) => b && sendSettings()}
        SFX={SFXS.cashoutSFX}
      >
        <TriangleSVG />
      </Button> */}
      <FastButton
        audio={audio}
        func={(b: boolean) => b && sendSettings()}
        SFX={aud}
        speed={speed}
      />
      <Button
        audio={audio}
        colors={{
          textColor: colors.secondary,
          background: colors.secondaryDark,
          borderColor: colors.secondary,
        }}
        width="178px"
        func={(b: boolean) => b && sendBet(stake)}
        SFX={SFXS.playSFX}
        customClass={betSent && "disable"}
      >
        PLAY
      </Button>
      <Button
        // audio={audio}
        // sfx={SFXS.goForwardSFX}
        colors={{
          textColor: colors.tertiary,
          background: colors.secondaryDark,
          borderColor: colors.secondary,
        }}
        func={(b: boolean) => {
          b && handleAbove("Auto")
        }}
        SFX={SFXS.goForwardSFX}
      >
        <AutoSVG />
      </Button>
    </Section>
  )
}

export const Section = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
`
